const BASE_FEE_RATE = 0.6
const TAX_RATE = 1.1
// 全額立替
// 送客手数料率(税込) = 0.66
export function calcCustomerTransferFeeRate(): number {
  return BASE_FEE_RATE * TAX_RATE
}

interface RemittanceInput {
  totalReimbursement: number
}

// 特殊ケース
// 立替金送金額 = 立替元本
export function calcRemittance({ totalReimbursement }: RemittanceInput): number {
  return totalReimbursement
}
